"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var styles = {
  root: {
    padding: "0 " + _tokens.spacing40,
    alignItems: 'center',
    margin: 'inherit',
    height: _tokens.sizingXxLarge1,
    '& svg': {
      height: _tokens.sizingXxLarge1
    }
  }
};
var HeaderBarLogo = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root,
    ref: ref
  }, children);
});
HeaderBarLogo.displayName = 'HeaderBarLogo';
HeaderBarLogo.propTypes = {
  /**  The content of the component. This component's children might be an image or brand name. */
  children: _propTypes.default.node.isRequired,
  /** Useful to extend the style applied to components. */
  classes: _propTypes.default.object
};
var _default = exports.default = (0, _styles.default)(styles)(HeaderBarLogo);